import httpService from './httpService';
import { resetPasswordUrl } from '../constants/apiEndPoints';

export function resetPasswordAPI(userId, timestamp, signature, password) {
    const data = {
        user_id: userId,
        timestamp,
        signature,
        password,
    };
    return httpService.post(resetPasswordUrl, data);
}
